import { Paper, Skeleton } from '@/shared/ui';

import {
  SKELETON_CONFIG,
  SKELETON_ELEMENT_HEIGHT
} from '@/features/markets/components/MarketsSkeleton/config';

export const MarketWidgetSkeleton = () => {
  return (
    <Paper
      sx={theme => ({
        width: 'calc(50% - 12px)',
        minWidth: 300,
        height: SKELETON_ELEMENT_HEIGHT,
        py: 4,
        px: 3,
        '& *': { mb: 3 },
        [theme.breakpoints.down('md')]: {
          width: '100%'
        }
      })}
    >
      {SKELETON_CONFIG.map(({ id, width }) => (
        <Skeleton
          key={id}
          width={`${width}%`}
        />
      ))}
    </Paper>
  );
};
